import React from 'react';
import './style.css';

const videos = [
  ['Glow', 'qw6SQ3oMh2M'],
  ["Sheila's monologue", 'szxJ-lxEwE4'],
  ['I Happen To Like New York', 'tLVLY3APhXY'],
  ['At the ballet', 'jiI7ZXMOxPw'],
  ['Ladies Who Lunch', 'YrjLOGCaNtw'],
];

function Videos() {
  return (
    <section id="videos" className="video-section">
      <div className="content-section">
        <div className="section-heading">
          <div><span className="eyebrow">Watch & listen</span><h2>Videos</h2></div>
          <span className="section-heading-note">Select a performance to watch on YouTube</span>
        </div>
        <div className="video-grid">
          {videos.map(([title, id], index) => (
            <article className={index === 0 ? 'video-card video-card-featured' : 'video-card'} key={id}>
              <a
                className="video-preview"
                href={`https://www.youtube.com/watch?v=${id}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Watch ${title} on YouTube`}
              >
                <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt="" loading="lazy" />
                <span className="video-play" aria-hidden="true">▶</span>
              </a>
              <div className="video-caption">
                <span>{String(index + 1).padStart(2, '0')} / Performance</span>
                <h3><a href={`https://www.youtube.com/watch?v=${id}`} target="_blank" rel="noopener noreferrer">{title} ↗</a></h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Videos;
